import React from 'react'
import { useDownloadableCsv } from 'utils/hooks/useGenerateDownloadableCsv'
import Button, { ButtonProps } from 'components/Button'

interface Props extends Omit<ButtonProps, 'children'> {
  csvData: object[]
  testSessionName: string
}

const InsuranceCountDownloadButton = ({ csvData, testSessionName }: Props) => {
  const csvUrl = useDownloadableCsv({ data: csvData })
  return (
    <Button
      appearance="outlined"
      colorVariant="info"
      href={csvUrl}
      download={`Insurance-Count-Test-Session-${testSessionName}.csv`}
    >
      Download insurance count
    </Button>
  )
}

export { InsuranceCountDownloadButton }
